var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        border: "",
        data: _vm.list,
        "header-cell-style": { background: "#F1F1F1", color: "#333333" },
      },
    },
    [
      _vm.selectable
        ? _c("el-table-column", {
            attrs: { width: "50", align: "center" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: scope.row.id },
                          model: {
                            value: _vm.selected,
                            callback: function ($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected",
                          },
                        },
                        [_c("span")]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1451024521
            ),
          })
        : _vm._e(),
      _c("el-table-column", {
        attrs: { label: "订单信息", width: "210px" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("div", [_vm._v("订单号：" + _vm._s(scope.row.id))]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(" 卡类型：" + _vm._s(scope.row.card_bin_name) + " "),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 发放类型：" +
                      _vm._s(_vm.sendTypeMap[scope.row.send_type] || "") +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v("卡名称：" + _vm._s(scope.row.card_name)),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "销售信息" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v("组织：" + _vm._s(scope.row.organize_name)),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(" 销售负责人：" + _vm._s(scope.row.username) + " "),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v(
                      "交付负责人：" + _vm._s(scope.row.the_loser_name || "-")
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 客户名称：（" +
                      _vm._s(scope.row.customer_id) +
                      "）" +
                      _vm._s(scope.row.company_name) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 创建人：" +
                      _vm._s(scope.row.add_user_name) +
                      "-" +
                      _vm._s(scope.row.created_at) +
                      " "
                  ),
                ]),
                scope.row.opportunity_name
                  ? _c("div", { staticClass: "table__item-style" }, [
                      _vm._v(
                        " 商机名称：" + _vm._s(scope.row.opportunity_name) + " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "售卡信息", width: "200px" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isTimes(scope.row) ? "可售次数：" : "可售点数："
                      ) +
                      _vm._s(scope.row.available_points) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isTimes(scope.row) ? "已售次数：" : "已售点数："
                      ) +
                      _vm._s(scope.row.card_sale_points) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(" 已售数量：" + _vm._s(scope.row.card_sale_num) + " "),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "订单金额", width: "200px" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 订单金额：" +
                      _vm._s(_vm._f("moneyFormat")(scope.row.money)) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 激活金额：" +
                      _vm._s(
                        _vm._f("moneyFormat")(scope.row.activation_amount)
                      ) +
                      " "
                  ),
                ]),
                Number(scope.row.diff_money) !== 0
                  ? _c("div", { staticClass: "table__item-style" }, [
                      _vm._v(
                        " 偏差金额：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.diff_money)) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 实际应收：" +
                      _vm._s(_vm._f("moneyFormat")(scope.row.shou_money)) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "table__item-style" }, [
                  _vm._v(
                    " 回款金额：" +
                      _vm._s(_vm._f("moneyFormat")(scope.row.finance_money)) +
                      " "
                  ),
                ]),
                Number(scope.row.service_cost) !== 0
                  ? _c("div", { staticClass: "table__item-style" }, [
                      _vm._v(
                        " 优惠券成本：" +
                          _vm._s(
                            _vm._f("moneyFormat")(scope.row.service_cost)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                Number(scope.row.company_cost) !== 0
                  ? _c("div", { staticClass: "table__item-style" }, [
                      _vm._v(
                        " 服务成本：" +
                          _vm._s(
                            _vm._f("moneyFormat")(scope.row.company_cost)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "订单状态", width: "110px" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                Number(scope.row.status) === 1
                  ? _c("el-tag", { attrs: { type: "warning" } }, [
                      _vm._v("驳回"),
                    ])
                  : _vm._e(),
                Number(scope.row.status) === 2
                  ? _c("el-tag", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v("运营审核中"),
                    ])
                  : _vm._e(),
                Number(scope.row.status) === 3
                  ? _c("el-tag", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v("vp审核中"),
                    ])
                  : _vm._e(),
                Number(scope.row.status) === 0
                  ? _c("el-tag", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v(_vm._s(scope.row.audit_status_des)),
                    ])
                  : _vm._e(),
                Number(scope.row.status) === 4
                  ? _c("el-tag", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v("审核通过"),
                    ])
                  : _vm._e(),
                Number(scope.row.status) === 5
                  ? _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-top": "5px" },
                        attrs: { type: "success" },
                      },
                      [_vm._v("订单确认")]
                    )
                  : _vm._e(),
                _c("el-tag", { staticStyle: { "margin-top": "5px" } }, [
                  _vm._v(_vm._s(scope.row.rule_des)),
                ]),
                _c(
                  "el-tag",
                  {
                    staticStyle: { "margin-top": "5px" },
                    attrs: {
                      type:
                        Number(scope.row.create_commission) === 0
                          ? "warning"
                          : "success",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        Number(scope.row.create_commission) === 0
                          ? "未达成"
                          : "已达成"
                      )
                    ),
                  ]
                ),
                scope.row.satisfaction_survey_status_des
                  ? _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-top": "5px" },
                        attrs: { type: _vm.satisfactionType(scope.row) },
                      },
                      [_vm._v(_vm._s(scope.row.satisfaction_survey_status_des))]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "操作", align: "left", width: "100px", fixed: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("detail", scope.row)
                      },
                    },
                  },
                  [_vm._v("详情")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }